define(['edge/platform/base/BaseCtrl'], (BaseCtrl) => {
    const fn = ($scope, $stateParams, $state, ModalService, $q, ProducerContactService, $rootScope) => {

        const ctrl = Object.create(BaseCtrl);
        const submissionVM = $stateParams.submission;
        //const flowModel = StateUtils.activeDataForState(true).flowModel;
        ctrl.init = ()=> {
            

            
            // Get quote id from submission
            var quoteID = submissionVM.quoteID;
            $scope.quoteNo = submissionVM.quoteID;
            $scope.getAddress = ()=> {
                if (submissionVM.persons[0].primaryAddress) {
                    const addr = submissionVM.persons[0].primaryAddress;
                    return [addr.addressLine1,
                        `${addr.city}, ${addr.state} ${addr.postalCode}`];
                }

                /*const addr = scope.submission.draftData.policyAddress;
                return [addr.addressLine1,
                    `${addr.city}, ${addr.state} ${addr.postalCode}`];*/
            };
            $scope.address = submissionVM.persons[0].primaryAddress.displayName;

            $scope.agentDetails = {
                
            };
            
            const producerCodeSummary = ProducerContactService.getProducerContactSummaryByQuoteId(quoteID);
            $q.when(producerCodeSummary, function(response){

                // Temp placeholder display for agent info
                //$scope.agentDetails.displayName = (response.producerOfRecord.description) ? response.producerOfRecord.description : response.displayName;
                //DE1866 : Commented out to pass hard code values for agents details as per the defect requirement

                // QnB Link on Agents wiebsites
                // Need to display producer information specific to EIA / AAOP / SP
                // AB - 09/18/2019
                //
        // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
        // AB - 11/23/2020

            if ($rootScope.Arg1 == null){
                var arg1 = $rootScope.Arg1
            }else{
                var arg1 = $rootScope.Arg1.toUpperCase()
            }

            switch(arg1){
                case "GORMISH":
                case "SEA":
                case "YOMTOB":
                    $scope.agentDetails.displayName = (response.displayName) ? response.displayName : response.producerOfRecord.description;
                     var primaryAddress = response.producerOfRecord.address ? response.producerOfRecord.address : response.primaryAddress ;
                     if(primaryAddress && primaryAddress.displayName != "<empty>"){
                        $scope.agentDetails.primaryAddress = primaryAddress.displayName
                      };
                     $scope.agentDetails.phoneNumber = (response.phoneNumber) ? response.phoneNumber : "";
                     $scope.agentDetails.email = (response.email) ? response.email : "";
                  break
                default:
                    $scope.agentDetails.displayName = "AAA Insurance";
                    $scope.agentDetails.primaryAddress = "6600 AAA Dr Charlotte, NC 28212";
                    $scope.agentDetails.phoneNumber = "1-877-840-8642";
                }
            },
            function(response){
            });
        };


        ctrl.doNavigate = function () {
            var account = submissionVM.draftData.accountHolder;
            account.subtype = 'Person';
            account.accountExists = true;
            account.accountNumber = submissionVM.draftData.accountNumber;
            var postalCode = account.primaryAddress.postalCode;

            var details = {
                postalCode: postalCode,
                account: account,
                effectiveDate : new Date(),
                productCode: 'PersonalAuto'
            }
            $state.go('quoteentry', details);
        }
        return ctrl.create($scope);
    };
    
    fn.$inject = ['$scope', '$stateParams', '$state', 'ModalService', '$q', 'ProducerContactService', '$rootScope'];
    
    return fn;
});


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/ho/controllers/NextStepsCtrl.js
 **/